import React from 'react';
import Sidebar from '../components/Home/Sidebar';
import '../assets/css/style.css';

const HomeLayout = ({ children }) => {
    return (
        <div className="chat-screens">
            <div className="outer-container">
                <div className="sidebar">
                    <Sidebar />
                </div>
                <div className="chat-container">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default HomeLayout;